SendEmailTemplateModalController.$inject = ["$logFactory", "$q", "$sce", "$translate", "$uibModal", "$window", "contractService", "invalidMergeFieldErrorMsgKey", "legacyService", "logger", "messageTypes", "smtpProviderTypes", "templateEmail", "templateService", "toaster", "translateErrorKeys", "warningTitleKey"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
/* injects from baggage-loader */
require('./send-email-template-modal.component.html');
import angular from 'angular';
import { OpportunitiesModule } from '../../../core/opportunities.module';
import _ from 'lodash';
import { downloadArraybufferResponse } from '../../../utilities/http';
OpportunitiesModule.component('sendEmailTemplateModal', {
  templateUrl: '/app/components/deal-sheet/modals/send-email-template-modal.component.html',
  controller: SendEmailTemplateModalController,
  bindings: {
    close: '&',
    resolve: '<',
    dismiss: '&'
  }
});

/* @ngInject*/
function SendEmailTemplateModalController($logFactory, $q, $sce, $translate, $uibModal, $window, contractService, invalidMergeFieldErrorMsgKey, legacyService, logger, messageTypes, smtpProviderTypes, templateEmail, templateService, toaster, translateErrorKeys, warningTitleKey) {
  var $ctrl = this;
  var $log = $logFactory.get('emailTemplateModal');
  $ctrl.templates = [];
  $ctrl.template;
  $ctrl.templateBody;
  $ctrl.templateLetterheadImageUrl;
  $ctrl.toggleEditButtonKey = "editEmailTemplate";
  $ctrl.isEditableTemplate = false;
  $ctrl.$onInit = $onInit;
  $ctrl.$onChanges = $onChanges;
  $ctrl.changeTemplate = changeTemplate;
  $ctrl.downloadPdf = downloadPdf;
  $ctrl.archivePdf = archivePdf;
  $ctrl.onResultSendTestEmail = onResultSendTestEmail;
  $ctrl.onResultSendEmail = onResultSendEmail;
  $ctrl.getTemplateEmailContent = getTemplateEmailContent;
  $ctrl.emailDisabled = false;
  $ctrl.canSendEmail = true;
  $ctrl.disabledEmailTitle = "";
  $ctrl.doNotEmail;
  $ctrl.toast;
  $ctrl.dealerId;
  $ctrl.onEdit = onEdit;
  $ctrl.toggleEditTemplate = toggleEditTemplate;
  $ctrl.previewTemplate = previewTemplate;
  $ctrl.attachProposal = false;
  $ctrl.attachmentGenerationResponse = {};
  $ctrl.vehicleTypes = [];
  $ctrl.replMakeId;
  $ctrl.atForFromAddr = "at";
  function $onChanges(changes) {
    if (changes.resolve) {
      $ctrl.templateBody = $ctrl.resolve.value;
    }
  }
  function previewTemplate() {
    var templateBody = $ctrl.templateBody;
    if (templateBody == null) templateBody = "";
    templateService.storePreviewTemplate(templateBody);
    var newWindow = $window.open('about:blank');
    newWindow.location = templateService.getTemplateEmailPreviewUrl($ctrl.resolve.opportunity.id, $ctrl.template.id, $ctrl.replMakeId);
  }
  function toggleEditTemplate() {
    $ctrl.isEditableTemplate = !$ctrl.isEditableTemplate;
    if ($ctrl.isEditableTemplate) $ctrl.toggleEditButtonKey = "cancelEditEmailTemplate";else $ctrl.toggleEditButtonKey = "editEmailTemplate";
  }
  function $onInit() {
    var _this = this;
    $ctrl.emailDisabled = false;
    $ctrl.canSendEmail = true;
    if ($ctrl.toast) {
      toaster.clear($ctrl.toast);
    }
    $ctrl.dealerId = $ctrl.resolve.opportunity.dealerId;
    $ctrl.replMakeId = $ctrl.resolve.opportunity.replacementVehicle.makeID;
    this.workingPromise = templateService.getTemplatesForDealerId($ctrl.dealerId).then(function (templates) {
      _this.templates = templates;
      if (templates) {
        if ($ctrl.resolve.defaultTemplateId) {
          $ctrl.template = _.find(templates, {
            id: $ctrl.resolve.defaultTemplateId
          });
          toggleEditTemplate();
        }
        setDealerFromAddress();
      }
    });
    getTranslations();
  }
  function getTranslations() {
    $q.all({
      'new': $translate('new'),
      'used': $translate('used'),
      'cpo': $translate('cpo'),
      'atForFromAddr': $translate('atForFromAddr')
    }).then(function (translations) {
      $ctrl.vehicleTypes[0] = translations.new;
      $ctrl.vehicleTypes[1] = translations.used;
      $ctrl.vehicleTypes[2] = translations.cpo;
      $ctrl.atForFromAddr = translations.atForFromAddr;
    });
  }
  function changeTemplate() {
    var templateId = $ctrl.template.id;
    var opportunityId = $ctrl.resolve.opportunity.id;
    var replacement = $ctrl.resolve.opportunity.replacementVehicle;
    var vehicleColor = "";
    if (replacement.exteriorColor != null && replacement.interiorColor === null) {
      vehicleColor = replacement.exteriorColor;
    } else if (replacement.interiorColor != null && replacement.exteriorColor === null) {
      vehicleColor = ' / ' + replacement.interiorColor;
    } else if (replacement.exteriorColor != null && replacement.interiorColor != null) {
      vehicleColor = replacement.exteriorColor + ' / ' + replacement.interiorColor;
    }
    var replacementVehicle = {
      selectedMake: replacement.makeName,
      selectedModel: replacement.modelName,
      selectedYear: replacement.yearID,
      selectedTrim: replacement.trimName,
      selectedFullTrim: replacement.trimFullName,
      selectedNewUsed: $ctrl.vehicleTypes[replacement.type],
      selectedPrice: replacement.price,
      selectedMileage: replacement.odometer,
      selectedColor: vehicleColor,
      selectedStockNo: replacement.stockNo
    };
    $ctrl.workingPromise = templateService.getMergedTemplate({
      opportunityId: opportunityId,
      templateId: templateId,
      replacementVehicle: replacementVehicle
    }).then(function (template) {
      if (template.invalidMergeFields.length > 0) {
        var invalidFlds = "";
        for (var i = 0; i < template.invalidMergeFields.length; i++) {
          invalidFlds += "<br>" + template.invalidMergeFields[i];
        }
        $translate([warningTitleKey, invalidMergeFieldErrorMsgKey]).then(function (translations) {
          toaster.pop({
            type: messageTypes.warning,
            title: translations.warningTitle,
            body: translations.invalidMergeFieldErrorMsg + invalidFlds,
            timeout: 0,
            bodyOutputType: 'trustedHtml',
            showCloseButton: true
          });
        });
      }
      $ctrl.templateBody = template.templateBody;
      $ctrl.templateSubject = _.find($ctrl.templates, {
        id: templateId
      }).templateSubject;
      $ctrl.template.invalidMergeFields = template.invalidMergeFields;
      $ctrl.templateLetterheadImageUrl = template.templateLetterheadImageUrl;
      $ctrl.readOnlyText = $sce.trustAsHtml($ctrl.templateBody);
    });
  }
  function downloadPdf() {
    if (typeof $ctrl.templateOutputId == 'number') {
      throw new Error("Email template has not been filled.");
    }
    var opportunityId = $ctrl.resolve.opportunity.id;
    logger.success("generatingPDF");
    return templateService.createPdf(opportunityId, $ctrl.template, $ctrl.templateBody, $ctrl.templateLetterheadImageUrl).then(function (t) {
      $ctrl.templateOutput = t;
      return templateService.downloadPdf($ctrl.templateOutput.id, $ctrl.templateOutput.templateName);
    }).then(function () {
      $ctrl.readyToArchive = true;
      templateService.archivePdf($ctrl.templateOutput.id);
    });
  }
  function archivePdf() {
    //PDF is now auto archived on Print to PDF for WEBUI-11223, on downloadPdf
    return $ctrl.dismiss();
  }
  function onResultSendTestEmail(edit) {
    onSendEmail(edit.subject, "", $ctrl.emailFromAddress, $ctrl.templateBody, true, edit.emailTo);
  }
  function onResultSendEmail(edit) {
    onSendEmail(edit.subject, edit.emailTo, $ctrl.emailFromAddress, $ctrl.templateBody, false, "");
  }
  function checkCanSendEmail() {
    if ($ctrl.emailDisabled) {
      logger.warning("emailDisabledWarning");
      $ctrl.canSendEmail = false;
      return;
    }
    if ($ctrl.resolve.opportunity) {
      $ctrl.doNotEmail = $ctrl.resolve.opportunity.customer.doNotEmail;
      if ($ctrl.doNotEmail) {
        logger.warning("doNotEmailCheckedWarning");
        $ctrl.canSendEmail = false;
      }
    }
  }
  function setDealerFromAddress() {
    templateService.getDealerOutboundEmailProviderInfo($ctrl.dealerId).then(function (result) {
      $ctrl.emailFromAddress = result == smtpProviderTypes.custom ? $ctrl.resolve.opportunity.userProfile.email : templateEmail.mailFrom;
      $ctrl.emailDisabled = result === smtpProviderTypes.none;
      checkCanSendEmail();
    });
  }
  function onSendEmail(_x, _x2, _x3, _x4, _x5, _x6) {
    return _onSendEmail.apply(this, arguments);
  }
  function _onSendEmail() {
    _onSendEmail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(subject, to, from, body, isTestEmail, testTo) {
      var upgradeProposalCalcParameters, outboundTemplateInfo, emailResponse, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(typeof body === 'undefined' || body === null || body === '')) {
              _context.n = 1;
              break;
            }
            logger.warning("blankTemplateWarning");
            _context.n = 7;
            break;
          case 1:
            upgradeProposalCalcParameters = null;
            if (!$ctrl.attachProposal) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return legacyService.getCalculationParameters($ctrl.resolve.opportunity);
          case 2:
            upgradeProposalCalcParameters = _context.v;
          case 3:
            outboundTemplateInfo = {
              userId: $ctrl.resolve.opportunity.userProfile.userId,
              entityID: $ctrl.resolve.opportunity.id,
              templateId: $ctrl.template.id,
              templateName: $ctrl.template.templateName,
              isTestEmail: isTestEmail,
              testToAddress: testTo,
              toAddress: to,
              subject: subject,
              contentHtml: body,
              maxEmailsPerEntityPerDay: 0,
              replMakeId: $ctrl.replMakeId
            };
            logger.success("sendingEmail");
            _context.p = 4;
            _context.n = 5;
            return templateService.sendEmail(outboundTemplateInfo, upgradeProposalCalcParameters);
          case 5:
            emailResponse = _context.v;
            logger.success("emailSuccessMessage");
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            if (_t.data.error.translationKey) {
              $translate(_t.data.error.translationKey, _t.data.error.translationParameters).then(function (message) {
                return logger.warning(message, null, "emailErrorMessage");
              }).catch(function (err) {
                return $log.error(err);
              });
            } else {
              logger.warning(_t.data.error.message, null, "emailErrorMessage");
            }
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[4, 6]]);
    }));
    return _onSendEmail.apply(this, arguments);
  }
  function onEdit(action) {
    $ctrl.templateBody = action;
    $ctrl.readOnlyText = $sce.trustAsHtml($ctrl.templateBody);
  }
  function getTemplateEmailContent() {
    return $ctrl.workingPromise = templateService.getEmailPreviewContent($ctrl.resolve.opportunity.id, $ctrl.template.id, $ctrl.templateBody, $ctrl.replMakeId).then(setTemplateEmailContent);
  }
  function setTemplateEmailContent(content) {
    $ctrl.templateEmailContent = content;
    return true;
  }
}